import React from 'react';
import { stateKeys } from './constants/stateKeys';
import { StateProvider, useStateSelector } from './providers/state';
import { useSetImages } from './services/setImages';
import { EventsProvider } from './providers/events';
import { selectShowLightbox } from './utils/selectors';
import LightboxGroup from './ui/LightboxGroup';

const initalState = {
  [stateKeys.showLightbox]: false,
  [stateKeys.images]: [],
  [stateKeys.imageIndexes]: new Map(),
  [stateKeys.selectedImageIndex]: undefined,
};

const AttachmentsProvider = ({
  attachments,
  children,
  getAttachment,
  getExtension,
}) => {
  return (
    <StateProvider initialState={initalState}>
      <EventsProvider getAttachment={getAttachment} getExtension={getExtension}>
        <Content
          attachments={attachments}
          getAttachment={getAttachment}
          getExtension={getExtension}
        >
          {children}
        </Content>
      </EventsProvider>
    </StateProvider>
  );
};

export default AttachmentsProvider;

function Content({ attachments, children }) {
  useSetImages(attachments);

  return (
    <>
      {children}
      <LightboxBlock />
    </>
  );
}

function LightboxBlock() {
  const visible = useStateSelector(selectShowLightbox);

  if (!visible) return null;

  return <LightboxGroup />;
}
